import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=5a885909"
import script from "./Total.vue?vue&type=script&lang=ts"
export * from "./Total.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports